import { render, staticRenderFns } from "./employeesSub.vue?vue&type=template&id=495076fa&"
import script from "./employeesSub.vue?vue&type=script&lang=js&"
export * from "./employeesSub.vue?vue&type=script&lang=js&"
import style0 from "./employeesSub.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports